import { CircularProgress, FormControl, FormHelperText } from '@mui/material'
import { TextFieldElement, useWatch } from 'react-hook-form-mui'

type Props = { name: string; maxLength: number; disabled?: boolean; loading?: boolean }

export const AnnouncementInput = ({ name, maxLength = 0, disabled, loading }: Props) => {
    const value = useWatch({ name })
    const currentCharacterCount = value?.length || 0
    const atLimit = !!maxLength && value?.length === maxLength

    return (
        <FormControl disabled={disabled}>
            <TextFieldElement
                name={name}
                variant="outlined"
                inputProps={{ maxLength }}
                value={value}
                disabled={disabled || loading}
                multiline
                InputProps={{
                    endAdornment: loading ? <CircularProgress size={18} /> : undefined,
                }}
            />
            <FormHelperText sx={{ textAlign: 'right' }} error={atLimit}>
                {loading || !maxLength ? ' ' : `Limit: ${currentCharacterCount} / ${maxLength}`}
            </FormHelperText>
        </FormControl>
    )
}

export type { Props as AnnouncementInputProps }
